<figure class="badge-progress">
  <span *ngIf="showTitle">{{ activityData.name }}</span>
  <div class="badge badge--{{ activityData.defaultColor }} badge-progress--size-{{ currentIconLevels }} badge-progress--fill-{{ currentIconLevel }}" style="--w:{{ size }}rem">
    <i [class]="activityData.levels.length >= currentIndex ? activityData.levels[currentIndex].iconCss : ''"></i>
  </div>
  <figcaption *ngIf="showCaption" class="badge-caption">{{ currentIconLevel }}/{{ currentIconLevels }}</figcaption>
</figure>
